module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (229).03f7b5a3.jpg";